<!--
 * @Author: cheesekun
 * @Date: 2021-03-02 09:30:09
 * @LastEditors: cheesekun
 * @LastEditTime: 2021-03-17 09:27:04
 * @FilePath: \dc-wsy-sign-in-activity-horizontal-front\src\components\Tip\index.vue
-->
<template>
  <div class="tip">
    <transition-group name="fadeInDown">
      <div
        class="tip-main"
        v-for="item in notices"
        :key="item.name"
      >
        <div
          class="tip-content"
        >
          <!-- <img
            src="../../../assets/tip-icon.png"
            alt="tip"
          > -->
          <p>{{ item.content }}</p>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
let seed = 0

function getUuid () {
  return `tip_${seed++}`
}

export default {
  name: 'VTip',
  data () {
    return {
      notices: []
    }
  },
  methods: {
    add (notice) {
      const name = getUuid()
      const _notice = Object.assign({
        name
      }, notice)
      this.notices.push(_notice)
      // 定时移除，单位：秒
      const duration = notice.duration
      const timer = window.setTimeout(() => {
        this.remove(name, timer)
      }, duration * 1000)
    },
    remove (name, timer) {
      this.notices.find((notice, i) => {
        if (notice.name === name) {
          this.notices.splice(i, 1)
        }
      })
      window.clearTimeout(timer)
    }
  }
}
</script>

<style scoped lang='less'>
@import url('~@/styles/mixin.less');
.tip{
  position: fixed;
  min-width: 400px;
  max-width: 90%;
  // min-height: 44px;
  // height: auto;
  top: 116px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999999;
  .tip-content{
    display: flex;
    justify-content: center;
    align-items: center;
    // flex-wrap: nowrap;
    min-height: 105px;
    height: auto;
    padding: 10px 40px;
    // border-radius: 60px;
    background-image: url('../../assets/bg-tip.png');
    background-size: 100% 100%;
    // img {
    //   width: 20px;
    //   height: 20px;
    //   margin-right: 12px;
    //   display: block;
    // }
    p {
      font-size: 24px;
      color: #822117;
    }
  }
}
</style>
